module.exports = __webpack_public_path__ + "assets/img/icon-question-gray.5ba25f9e.png";